var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3437_829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9453 12.8516V18.6928L19.3294 15.7976L13.9453 12.8516Z",
    fill: "#20ACE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9746 0H8C3.60635 0 0 3.60635 0 8.0254V24C0 28.3937 3.60635 32 8 32H23.9746C28.3937 32 32 28.3937 32 23.9746V8.0254C32 3.60635 28.3937 0 23.9746 0ZM25.9048 16.7873C25.9048 18.4635 25.7524 20.1651 25.7524 20.1651C25.7524 20.1651 25.5746 21.5873 24.9905 22.2222C24.2286 23.0603 23.3905 23.0603 23.0095 23.1111C20.2159 23.3143 16.0254 23.3397 16.0254 23.3397C16.0254 23.3397 10.819 23.2635 9.21905 23.1111C8.7873 23.0349 7.77143 23.0603 7.00952 22.2222C6.4 21.5873 6.24762 20.1651 6.24762 20.1651C6.24762 20.1651 6.09524 18.4635 6.09524 16.7873V15.2127C6.09524 13.5365 6.24762 11.8349 6.24762 11.8349C6.24762 11.8349 6.4254 10.4127 7.00952 9.77778C7.77143 8.93968 8.60952 8.91429 8.99048 8.86349C11.8095 8.66032 16 8.63492 16 8.63492C16 8.63492 20.1905 8.66032 22.9841 8.86349C23.3651 8.91429 24.2286 8.93968 24.9905 9.75238C25.6 10.3873 25.7524 11.8349 25.7524 11.8349C25.7524 11.8349 25.9048 13.5365 25.9048 15.2127V16.7873Z",
    fill: "#20ACE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3437_829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ada243e6b504f6e7fe6ede3cc9292609.svg";
export { ForwardRef as ReactComponent };